import React, {Component} from 'react';
import Parser from 'rss-parser'

class GuestPostContainer extends Component {
  state = {
    data: [],
    loading: false
  }

  static defaultProps = {
    showSnippet: false
  }

  componentDidMount() {
    this.setState({loading: true})
    this.loadRSS(this.props.url).then(feed => {
      this.setState({
        data: feed.items.filter(item => item.coverimage !== '').slice(0,5),
        loading: false
      })
    })
  }

  loadRSS = async (url) => {
    const parser = new Parser({
      customFields: {
        item: ['coverimage', 'weblink']
      }
    });
    const feed = await parser.parseURL(url);
    return feed
  }

  render() {
    if(this.state.loading) {
      return (<p>Loading...</p>);
    }

    const {data} = this.state;

    return (
      <div className="__guest_post_wrapper">
        {
          data.map((news) => (
            <div className="__guest_post_item_container">
              <a className="__guest_post_item_link" href={news.weblink} target="_blank">
                <img className="__guest_post_item_image" src={news.coverimage} />
                {
                  !this.props.showSnippet || (<p className="__guest_post_item_snippet">{news.contentSnippet}</p>)
                }
                <h4 className="__guest_post_item_title">{news.title}</h4>
              </a>
            </div>
          ))
        }
      </div>
    );
  }
}

export default GuestPostContainer;


// WEBPACK FOOTER //
// ./src/GuestPostContainer.js